<!--
 * @Author: DY
 * @Date: 2020-08-18 15:44:57
 * @LastEditTime: 2026-09-20 13:53:23
 * @LastEditors: DY
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud_Mibile\src\views\salesTerminal\productionRatio\matchingInfoSetting.vue
-->
<template>
    <v-touch
        @swiperight="swiperright"
        class="wrapper"
    >
        <div class="matchingInfoSetting">
            <van-nav-bar
                :title="titleText"
                :left-text="leftText"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <h4>{{ matchingInfo.plcw }}/{{ matchingInfo.plcwname }}</h4>
                <h5>生产配比</h5>
                <div class="ListBox">
                    <van-field
                        v-model="matchingInfo.stock_category_name"
                        label="原料分类："
                        input-align="right"
                        readonly
                    ></van-field>
                    <van-field
                        v-model="matchingInfo.material_child_name"
                        label="原料子类："
                        input-align="right"
                        readonly
                    ></van-field>
                    <van-field
                        is-link
                        readonly
                        v-model="matchingInfo.material_name"
                        label="规格："
                        placeholder="请选择"
                        input-align="right"
                        :class="{'readonly': isReadOnly}"
                        @click="selectSpecifications()"
                    ></van-field>
                    <van-field
                        v-model="matchingInfo.experiment_quantity"
                        label="试验配比用量(kg)："
                        input-align="right"
                        readonly
                    ></van-field>
                    <van-field
                        v-model="matchingInfo.product_quantity"
                        label="施工配比用量(kg)："
                        input-align="right"
                        placeholder="请输入"
                        :readonly="isReadOnly"
                        @input="constructionRatio"
                        :class="{'readonly': isReadOnly}"
                    ></van-field>
                    <van-field
                        v-model="matchingInfo.moisture_ratio"
                        v-if="matchingInfo.stock_category == 'F3-01-XN-01'"
                        label="含水率(%)："
                        input-align="right"
                        placeholder="请输入"
                        :readonly="isReadOnly"
                        @input="moistureContentChange"
                        :class="{'readonly': isReadOnly}"
                    ></van-field>
                </div>
                <template v-if="matchingData">
                    <h5>试验配比</h5>
                    <div class="ListBox">
                        <van-field
                            v-model="matchingData.stock_category_name"
                            label="原料分类："
                            input-align="right"
                            readonly
                        ></van-field>
                        <van-field
                            v-model="matchingData.material_child_name"
                            label="原料子类："
                            input-align="right"
                            readonly
                        ></van-field>
                        <van-field
                            v-model="matchingData.material_name"
                            label="原料规格："
                            input-align="right"
                            readonly
                        ></van-field>
                        <van-field
                            v-model="matchingData.difference_quantity"
                            label="差值："
                            input-align="right"
                            class="difference"
                            readonly
                        ></van-field>
                        <van-field
                            v-model="matchingData.product_quantity"
                            label="施工配比用量(kg)："
                            input-align="right"
                            readonly
                        ></van-field>
                        <van-field
                            v-model="matchingData.theory_quantity"
                            label="理论配比用量(kg)："
                            input-align="right"
                            readonly
                        ></van-field>
                        <van-field
                            v-model="matchingData.theory_quantity_min"
                            label="最小值(kg)："
                            input-align="right"
                            readonly
                        ></van-field>
                        <van-field
                            v-model="matchingData.theory_quantity_max"
                            label="最大值(kg)："
                            input-align="right"
                            readonly
                        ></van-field>
                    </div>
                </template>
                <van-action-sheet
                    v-model="specificationsShow"
                    :actions="materialModelSelectData"
                    cancel-text="取消"
                    close-on-click-action
                    @select="materialChildSelectChange"
                    @cancel="specificationsShow = false"
                ></van-action-sheet>
            </section>
            <footer>
                <button @click="cancelSelect">
                    返回
                </button>
                <button @click="preservation" v-if="isReadOnly == false">
                    确认
                </button>
            </footer>
        </div>
    </v-touch>
</template>
<script>
import NP from 'number-precision';

export default {
    // 料仓配比信息设置
    name: 'matching-info-setting',
    components: {},
    props: {},
    data() {
        return {
            titleText: '料仓配比信息设置',
            leftText: '关联配比',
            listIndex: 0,
            // 料仓信息数据
            matchingInfo: {},
            // 试验配比数据
            matchingData: null,
            // 选择规格弹出层状态
            specificationsShow: false,
            // 原材料规格下拉列表数据
            materialModelSelectData: [],
            // 是否只读
            isReadOnly: false,
        };
    },
    created() {
        if (this.$route.params.leftText) {
            this.titleText = '料仓配比信息';
            this.leftText = this.$route.params.leftText;
        }
        if (this.$route.params.isReadOnly) {
            this.isReadOnly = this.$route.params.isReadOnly;
        }
        this.matchingInfo = this.$route.params.data;
        this.matchingData = this.$route.params.matchingData;
        this.listIndex = this.$route.params.index;
    },
    mounted() { },
    activited() { },
    update() { },
    beforeRouteUpdate() { },
    methods: {
    // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 返回
        cancelSelect() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 是否有提示
        isPlaceholder(data) {
            let newDom = '';
            if (data === false) {
                newDom = '请输入';
            }
            return newDom;
        },
        // 选择规格
        selectSpecifications() {
            if (this.isReadOnly) {return;}
            this.materialChildSelect();
        },
        // 施工配比修改事件
        constructionRatio() {
            if (this.matchingData) {
                this.matchingData.product_quantity = this.matchingInfo.product_quantity;
                this.matchingData.difference_quantity = NP.minus(this.matchingData.theory_quantity || 0, this.matchingData.product_quantity || 0);
            }
        },
        // 含水率修改
        moistureContentChange() {
            if ((this.matchingInfo.moisture_ratio || 0) > 0 && (this.matchingInfo.experiment_quantity || 0) > 0) {
                // eslint-disable-next-line max-len
                this.matchingInfo.product_quantity = NP.times(this.matchingInfo.experiment_quantity || 0, NP.plus(1, NP.divide(this.matchingInfo.moisture_ratio, 100)));
            }
        },
        // 根据料场类型stock_code获取原材料籽料select数据
        materialChildSelect() {
            if (this.materialModelSelectData.length > 0) {
                this.specificationsShow = true;
            } else {
                this.$axios
                    .get(`/interfaceApi/Procurement/stock/materials/stock_code/${this.matchingInfo.stock_code}`)
                    .then(res => {
                        res.forEach(item => {
                            item.name = item.material_name;
                        });
                        this.materialModelSelectData = res;
                        this.specificationsShow = true;
                    })
                    .catch(error => {
                        this.$dialog({ message: error.ErrorCode.Message });
                    });
            }
        },
        // 确认选择规格
        materialChildSelectChange(data) {
            this.matchingInfo.material_name = data.material_name;
        },
        // 保存
        preservation() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'correlationRatio',
                params: {
                    matchingInfo: this.matchingInfo,
                    matchingData: this.matchingData,
                    index: this.listIndex,
                },
            });
            this.$router.go(-1);
        },
    },
    filter: {},
    computed: {},
    watch: {},
};
</script>

<style lang="stylus">
.matchingInfoSetting
    height 100%
    section
        padding 15rpx
        height calc(100% - 84rpx)
        overflow scroll
        background #F0F0F0
        -webkit-overflow-scrolling touch
        h4
            font-size 16rpx
            line-height 16rpx
            color #3495FB
            margin-bottom 13rpx
        h5
            font-size 12rpx
            margin-bottom 10rpx
            color #666666
        .ListBox
            border-radius 4px
            overflow hidden
            margin-bottom 15rpx
            &:last-child
                margin-bottom 0
            input
                &::-webkit-input-placeholder
                    color red
            .van-cell
                .van-cell__title
                    width 45%
                .van-cell--clickable
                    &:active
                        background-color #fff
            .difference
                background rgba(224, 32, 32, 0.04)
                &:after
                    border-color rgba(224, 32, 32, 0.14)
                .van-cell__title,
                .van-field__control
                    color #E02020
            .readonly
                input
                    &::-webkit-input-placeholder
                        color #fff
    footer
        height 40rpx
        display flex
        button
            flex 1
            height 40rpx
            background #fff
            font-size 16rpx
            color #E50C0D
            border 1px solid #E50C0D
            &:before
                padding-right 5rpx
            &:nth-of-type(2)
                background #E50C0D
                color #fff
</style>
